import { Requester } from './Requester';
import { IUser, TableQueryParams } from '../types';

export const GetCicUsers = async (
    options: TableQueryParams
): Promise<{ users: IUser[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ users: IUser[]; totalRecords: number }>({
            path: `users/admin/paged`,
            method: 'PUT',
            payload: options
        });

        if ('users' in response && Array.isArray(response.users)) return response;
        return null;
    } catch (e) {
        console.error('Get CIC users request failed');
        return Promise.reject(e);
    }
};
